import { FluVaccineComponent } from './flu-vaccine.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';

const requestAppointmentRoutes: Routes = [
  {path: 'flu-vaccine/:id', component: FluVaccineComponent}
];

@NgModule({
  imports: [
    RouterModule.forChild(requestAppointmentRoutes)
  ],
  exports: [
    RouterModule
  ],
  providers: []
})

export class FluVaccineRoutingModule { }



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/flu-vaccine/flu-vaccine.routing.ts